// 🔹 Stylesheets
import './VerifyEmail.scss';

// 🔹 React Core
import React, { useState, useEffect } from 'react';

// 🔹 Routing
import { useNavigate, useLocation } from 'react-router-dom';

// 🔹 Firebase
import { sendEmailVerification } from 'firebase/auth';
import { auth } from 'src/config/firebase';

// 🔹 Libraries
import toast from 'react-hot-toast';

// 🔹 Components
import { Button } from '../../components/Button/Button';
import { ReactComponent as EmailIcon } from '../../../../assets/images/onboarding-trainer/email.svg';
import { ReactComponent as BackIcon } from '../../../../assets/images/onboarding-trainer/back.svg';
import { ReactComponent as LogoIcon } from '../../../../assets/images/onboarding-trainer/logo.svg';

export const VerifyEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email = 'your email', fromLogin = false } = location.state || {};

  const [countdown, setCountdown] = useState(fromLogin ? 0 : 60);
  const [isResending, setIsResending] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (countdown > 0) {
      timer = setInterval(() => setCountdown((c) => c - 1), 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  const handleResend = async () => {
    if (!auth.currentUser) {
      toast.error('Session expired. Please sign in again to resend.');
      return;
    }
    try {
      setIsResending(true);
      const basePath = process.env.APP_BASENAME || '';
      await sendEmailVerification(auth.currentUser, {
        url: `${window.location.origin}${basePath}/onboarding-trainer/login?type=trainer`,
      });
      toast.success('Verification email sent!');
      setCountdown(60);
    } catch (error: any) {
      toast.error(error?.message || 'Failed to resend email');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="onboarding-verify-email-container">
      <div className="verify-email-box">
        <div className="verify-email-header">
          <div className="logo-placeholder">{<LogoIcon />}</div>
          <h1 className="verify-email-title">{'Verify your email'}</h1>
          <p className="verify-email-subtitle">
            {'Before logging in, please check your inbox and spam folder for a verification link.'}
          </p>
        </div>

        <div className="email-sent-card-container">
          <div className="email-sent-info-box">
            <div className="email-icon-wrapper">{<EmailIcon />}</div>
            <div className="email-details">
              <span className="email-sent-label">{'EMAIL SENT TO:'}</span>
              <span className="email-address">{email}</span>
            </div>
          </div>

          <Button
            variant="primary"
            className="submit-btn bg-white w-100"
            onClick={() => {
              window.location.href = `mailto:${email}`;
            }}
          >
            {'Open email app'}
          </Button>

          <button
            type="button"
            className="resend-email-link"
            disabled={countdown > 0 || isResending}
            onClick={handleResend}
          >
            {countdown > 0 ? `Resend email in ${countdown}s` : 'Resend email'}
          </button>
        </div>

        <Button
          variant="outline"
          className="submit-btn back-to-login"
          onClick={() => navigate('/onboarding-trainer/login')}
        >
          {<BackIcon />} Back to Log in
        </Button>
      </div>
      <div className="verify-email-bg-glow"></div>
    </div>
  );
};
